export const isHtmlUploadRecord = (fileName = '', contentType = '') => {
  const normalizedFileName = fileName.toLowerCase();
  const normalizedContentType = contentType.toLowerCase();
  return normalizedFileName.endsWith('.html')
    || normalizedFileName.endsWith('.htm')
    || normalizedContentType.startsWith('text/html');
};
